[
  {
    "code": "CD-BN",
    "name": "Bandundu"
  },
  {
    "code": "CD-BC",
    "name": "Bas-Congo"
  },
  {
    "code": "CD-KW",
    "name": "Kasai-Occidental"
  },
  {
    "code": "CD-KE",
    "name": "Kasai-Oriental"
  },
  {
    "code": "CD-KA",
    "name": "Katanga"
  },
  {
    "code": "CD-KN",
    "name": "Kinshasa"
  },
  {
    "code": "CD-MA",
    "name": "Maniema"
  },
  {
    "code": "CD-NK",
    "name": "Nord-Kivu"
  },
  {
    "code": "CD-OR",
    "name": "Orientale"
  },
  {
    "code": "CD-SK",
    "name": "Sud-Kivu"
  },
  {
    "code": "CD-EQ",
    "name": "Équateur"
  }
]